import environmentResolver from '../resolver';
import localConfig from './local';
import featureConfig from './feature';
import preprodConfig from './preprod';
import sandboxConfig from './sandbox';
import performanceConfig from './performance';
import prodConfig from './prod';

const getEnvironmentConfig = () => {
	const runtimeEnvironment = environmentResolver(window.location.host);

	switch (runtimeEnvironment) {
		case 'local':
			return localConfig;

		case 'feature':
			return featureConfig;

		case 'preprod':
			return preprodConfig;

		case 'sandbox':
			return sandboxConfig;

		case 'performance':
			return performanceConfig;

		default:
			return prodConfig;
	}
};

export default getEnvironmentConfig;
